// extracted by mini-css-extract-plugin
export default {"tabDashboardUsage":"TabPerTenantUsage_tabDashboardUsage__3aZOn","rangeSelect":"TabPerTenantUsage_rangeSelect__N-sAF","card":"TabPerTenantUsage_card__0qdmh"};